import React, { Component, Fragment } from 'react';
import axios from 'axios';
import {
    Segment,
    Grid,
    Loader,
    Button,
    Header
} from 'semantic-ui-react';
import NonCycleStudentPersonalInformationForm from './NonCycleStudentPersonalInformationForm';
import { toast, ToastContainer } from 'react-toastify';
import { FormattedMessage } from 'react-intl';
import NonCycleStudentProgramInformationForm from './NonCycleStudentProgramInformationForm';

export const nonCycleStudentToBodyMapper = (student) => {
    return {
        id: student.id || null,

        firstName: student.firstName,
        lastName: student.lastName,
        email: student.email,
        jmbg: student.jmbg,
        dateOfBirth: student.dateOfBirth,
        birthPlaceName: student.birthPlaceName,
        genderId: student.gender ? student.gender.id : null,
        birthCountryId: student.birthCountry ? student.birthCountry.id : null,

        nonCycleProgramId: student.nonCycleProgram ? student.nonCycleProgram.id : null,
        academicYearId: student.academicYear ? student.academicYear.id : null,

        additionalInformation: student.additionalInformation,
        dropoutDate: student.dropoutDate,
        lockedAt: student.lockedAt,
        graduationDate: student.graduationDate,
        certificateNumber: student.certificateNumber,
    };
};

export const validateNonCycleStudent = (student) => {
    return {
        firstNameErr: !student.firstName || student.firstName.trim() === '',
        lastNameErr: !student.lastName || student.lastName.trim() === '',
        jmbgErr: !student.jmbg || student.jmbg.trim() === '',
        genderErr: !student.gender || !student.gender.id,
        dateOfBirthErr: !student.dateOfBirth || isNaN(new Date(student.dateOfBirth).getTime()),
        birthPlaceNameErr: !student.birthPlaceName || student.birthPlaceName.trim() === '',
        countryErr: !student.birthCountry || !student.birthCountry.id,

        nonCycleProgramErr: !student.nonCycleProgram || !student.nonCycleProgram.id,
        academicYearErr: !student.academicYear || !student.academicYear.id,
    };
};

class NonCycleStudentInputForm extends Component {
    state = {
        student: {},
        loadingStudent: true,
        creatingNonCycleStudent: false,
        errors: {},
    };

    constructor() {
        super();

        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleChange = this.handleChange.bind(this);
    }

    componentDidMount() {
        this.setState({
            student: {},
            loadingStudent: false
        });
    }

    handleSubmit = () => {
        this.setState({ errors: {} });
        const { student } = this.state;

        const body = nonCycleStudentToBodyMapper(student);

        const errors = validateNonCycleStudent(student);
        this.setState({ errors });
        if (Object.values(errors)
            .some((err) => err)) {
            // console.log(errors);
            toast(<FormattedMessage id="externalStudent.toast.fillRequiredFields"/>);
            return;
        }

        this.setState({ creatingNonCycleStudent: true }, () => {
            axios.post('/non-cycle-student', body)
                .then((res) => {
                    const createdStudent = res.data;

                    this.setState({
                        creatingNonCycleStudent: false,
                        student: {},
                    });

                    localStorage.setItem('nonCycleStudentId', createdStudent.id);
                    this.props.history.push({
                        pathname: '/neciklicni-studij/student',
                        state: {
                            student: createdStudent,
                            toastMessage: 'externalStudent.toast.createSuccess'
                        }
                    });
                })
                .catch(() => {
                    this.setState({
                        creatingNonCycleStudent: false,
                    });
                    toast(<FormattedMessage id="externalStudent.toast.createError"/>);
                });
        });
    };

    handleChange = (updatedFields) => {
        this.setState((prevState) => ({
            student: {
                ...prevState.student,
                ...updatedFields
            }
        }));
    };

    render() {
        const {
            student,
            errors,
            loadingStudent,
            creatingNonCycleStudent,
        } = this.state;

        return (
            <Fragment>
                <Header as="h1">
                    <Header.Content>{<FormattedMessage
                        id="externalStudent.createNonCycleStudyProgramStudent"/>}</Header.Content>
                </Header>

                {!loadingStudent && (
                    <Segment.Group raised>
                        <Segment>
                            <Header as="h3">
                                <Header.Content>{<FormattedMessage
                                    id="externalStudent.enterPersonalAndNonCycleStudyProgramData"/>}</Header.Content>
                            </Header>
                        </Segment>

                        <Segment>
                            <Grid stackable columns={2}>
                                <NonCycleStudentPersonalInformationForm student={student} errors={errors}
                                                                        onChangeStudent={this.handleChange}/>
                                <NonCycleStudentProgramInformationForm student={student} errors={errors}
                                                                       onChangeStudent={this.handleChange}/>
                            </Grid>
                        </Segment>

                        <Segment textAlign="right" padded>
                            <Button color="blue" onClick={this.handleSubmit} loading={creatingNonCycleStudent}>
                                {<FormattedMessage id="externalStudent.confirm"/>}
                            </Button>
                            <Button basic color="blue" disabled={creatingNonCycleStudent} onClick={() => {
                                this.setState({
                                    student: {},
                                    errors: {}
                                });
                            }}>
                                {<FormattedMessage id="externalStudent.clear"/>}
                            </Button>
                        </Segment>
                    </Segment.Group>
                )}

                {loadingStudent && (
                    <Segment basic>
                        <Loader active inline="centered"/>
                    </Segment>
                )}
                <ToastContainer position="top-right" hideProgressBar={true}/>
            </Fragment>
        );
    }
}

export default NonCycleStudentInputForm;



// WEBPACK FOOTER //
// ./src/views/NonCycleStudent/NonCycleStudentForms/NonCycleStudentInputForm.js